import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ErrorsList = (props) => {
    const { errors, ...otherProps } = props;
    if (errors) {
        return (
            <p className="text-left text-danger mb-0" {...otherProps}>
                {errors.map((error, index) => (
                    <Fragment key={index}>
                        <span
                            title="Error"
                            // eslint-disable-next-line
                            dangerouslySetInnerHTML={{
                                __html: error.description
                            }}
                        />
                        <br />
                    </Fragment>
                ))}
            </p>
        );
    } else {
        return null;
    }
};

ErrorsList.propTypes = {
    errors: PropTypes.array
};

export default ErrorsList;
